export var varArrowColor = 'var(--u112o10)';